// import { useLocation } from "react-router-dom";
var data = 0
export function baseUrl(url = '') {
    return `${process.env.REACT_APP_BASE_URL}${url === '' ? '' : '/' + url}`
}
export function geonodeUrl(url = '') {
    return `${process.env.REACT_APP_GEONODE_URL}${url === '' ? '' : '/' + url}`
}
export function localUrl(url = '') {
    let idioma=sessionStorage.getItem('languageId');

    if (idioma == null || idioma==''){
        idioma='';
    }else if(idioma=='es'){
        idioma=''
    }else{
        idioma='/'+idioma
    }
    let urlx = idioma+`${process.env.REACT_APP_LOCAL_URL?process.env.REACT_APP_LOCAL_URL+idioma.replace('/',''):''}${url === '' ? '' : '' + url}`
    console.log('url', urlx)
    return urlx
}

// export 

export function baseUrulBase() {
    
    console.log('uan urlasdasd')
}



export function urlQuery (location) {
  return new URLSearchParams(location.search)
}


export function getValuesQueryArray (location, param) {
    let res = []
    let qImport = urlQuery(location).get(param)
    if (qImport)
        res = qImport.split(',').filter(q => q)
    return res
}

